import React, { useState, useEffect } from 'react'
import Header from "components/Headers/Header.js";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import axios from 'axios'
import { Card, CardHeader, CardBody, Container, Row, Col, Spinner, Table, CardFooter, Button } from "reactstrap";
import { format } from 'date-fns'; 
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import {Link} from 'react-router-dom'

function InsuranceListDevice() {

    const [loading, setLoading]=useState(true)

    const [devices, setDevices]=useState([])

    const token = useSelector((state) => state.userLogin.userInfo.token);

    ////////////
    const { t, i18n } = useTranslation();  

    useEffect(() => {
        const storedLanguage = localStorage.getItem('selectedLanguageAFS');
        if (storedLanguage) {
        i18n.changeLanguage(storedLanguage);
        }
    }, [i18n]);
    ////////////

    useEffect(() => {

        const fetchData = async () => {

            try {
                const config = {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                }
                
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/list-devices-insurance-operator/`, config);

                console.log(response)

                if (response.status===200) {

                    setDevices(response.data)

                } else {

                }
                
            } catch (error) {
                
                console.log(error)

            } finally {
                setLoading(false)
            }
        };

        fetchData(); 
    }, [token]);

    return (
        <div>
            <Header/>
            {loading ? (
                <Container className="mt--15" fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                            <Spinner>
                                {t('Loading')}
                            </Spinner>
                        </Col>
                    </Row>
                </Container>
            ):( 
                <Container className="mt--15" fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                            <Card>
                                <CardHeader>
                                    <h3>{t('List of devices connected')}</h3>
                                </CardHeader>
                                <CardBody>
                                    {devices.length>0 ? (
                                        <>
                                            <h5>{t('List of the devices')}</h5>
                                            <br></br>
                                            <Table
                                                className="align-items-center table-flush"
                                                responsive>
                                                <thead>
                                                    <tr>
                                                        <th scope="col">{t('User First Name')}</th>
                                                        <th scope="col">{t('User Last Name')}</th>
                                                        <th scope="col">{t('User Email')}</th>
                                                        <th scope="col">{t('ID Sensor')}</th>
                                                        <th scope="col">{t('Is Active right now')}</th>
                                                        <th scope="col">{t('Last Request')}</th>
                                                        <th scope="col">{t('Number of Request')}</th>                  
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {devices.map((farmer, index) => (
                                                        <tr key={farmer.id}>
                                                            <td>{farmer.first_name}</td>
                                                            <td>{farmer.last_name}</td>
                                                            <td>{farmer.email}</td>
                                                            <td>{farmer.id_sensor}</td>
                                                            <td>
                                                                {farmer.is_right_now_active ? (
                                                                    <FaCheckCircle color="green" />
                                                                ) : (
                                                                    <FaTimesCircle color="red" />
                                                                )}
                                                            </td>
                                                            <td>{format(new Date(farmer.last_request_at), 'PPpp')}</td>
                                                            <td>{farmer.number_of_request}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </>
                                        
                                    ):(
                                        <>
                                            <h5>{t('No Devices Are connected to your account')}</h5>
                                        </>
                                    )}            
                                </CardBody>
                                <CardFooter>
                                    <Row>
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-2">
                                            <Link to="/">
                                                <Button color='primary'>
                                                    {t('Go back')} <i className="fas fa-rotate-left"></i>
                                                </Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </CardFooter>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            )}
        </div>
    )
}

export default InsuranceListDevice
